import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { ColumnsType } from 'antd/es/table';

import { useDocuments } from '@/entities/document';
import { PrivateDocumentCategory } from '@/entities/privateDocuments';
import { privateDocumentFieldSorter } from '@/entities/privateDocuments/helpers/privateDocumentFieldSorter';
import { Country } from '@/shared/components';
import { CollectionName, PrivateDocumentDto } from '@/shared/lib/sj-orm';

import { EntityTableOptions } from '../types';

export const usePrivateDocumentsTableOptions = (): EntityTableOptions<PrivateDocumentDto> => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'vfoImportDocument.columns' });
  const { getPrivateDocuments } = useDocuments();

  const privateDocuments = useMemo(() => getPrivateDocuments(), []);

  const columns = useMemo<ColumnsType<PrivateDocumentDto>>(
    () => [
      {
        key: 'title',
        title: t('title'),
        render: (item: PrivateDocumentDto) => item.name,
        sorter: privateDocumentFieldSorter.name,
      },
      {
        key: 'category',
        title: t('category'),
        width: 173,
        render: (item: PrivateDocumentDto) => (
          <PrivateDocumentCategory category={item.privateCategory} />
        ),
        sorter: privateDocumentFieldSorter.category,
      },
      {
        key: 'country',
        title: t('country'),
        width: 113,
        render: (item: PrivateDocumentDto) => <Country code={item.country} />,
        sorter: privateDocumentFieldSorter.country,
      },
    ],
    [],
  );

  return {
    collectionName: CollectionName.PRIVATE_DOCUMENTS,
    data: privateDocuments,
    columns,
  };
};
